module.exports = __webpack_public_path__ + "img/add_btn_icon120.34fbd2c9.svg";